import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { EyeIcon, EyeOffIcon, UserPlusIcon } from 'lucide-react';
export function Register() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [errors, setErrors] = useState<{
    email?: string;
    password?: string;
    confirmPassword?: string;
    terms?: string;
  }>({});
  const validateForm = () => {
    const newErrors: typeof errors = {};
    if (!email) {
      newErrors.email = 'Email-ul este obligatoriu';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Email-ul nu este valid';
    }
    if (!password) {
      newErrors.password = 'Parola este obligatorie';
    } else if (password.length < 8) {
      newErrors.password = 'Parola trebuie să aibă minim 8 caractere';
    }
    if (!confirmPassword) {
      newErrors.confirmPassword = 'Confirmarea parolei este obligatorie';
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = 'Parolele nu se potrivesc';
    }
    if (!acceptTerms) {
      newErrors.terms = 'Trebuie să accepți Termenii & Condițiile';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;
    // Navigate to onboarding with email
    navigate('/onboarding', {
      state: {
        email
      }
    });
  };
  return <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-6" data-id="element-7289">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="w-full max-w-md" data-id="element-7290">
        <div className="text-center mb-8" data-id="element-7291">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#357BEB] bg-opacity-10 rounded-2xl mb-4" data-id="element-7292">
            <UserPlusIcon className="w-8 h-8 text-[#357BEB]" data-id="element-7293" />
          </div>
          <h1 className="text-3xl font-bold text-[#132C53] mb-2" data-id="element-7294">
            Creează cont nou
          </h1>
          <p className="text-gray-600" data-id="element-7295">
            Începe parcursul tău în ecosistemul Cautlocuință.ro
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg p-8" data-id="element-7296">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-7297">
            <div data-id="element-7298">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7299">
                Email
              </label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} className={`w-full px-4 py-3 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-[#357BEB] focus:border-transparent`} placeholder="exemplu@email.com" data-id="element-7300" />
              {errors.email && <p className="mt-1 text-sm text-red-600" data-id="element-7301">{errors.email}</p>}
            </div>
            <div data-id="element-7302">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7303">
                Parolă
              </label>
              <div className="relative" data-id="element-7304">
                <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className={`w-full px-4 py-3 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-[#357BEB] focus:border-transparent pr-12`} placeholder="••••••••" data-id="element-7305" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700" data-id="element-7306">
                  {showPassword ? <EyeOffIcon className="w-5 h-5" data-id="element-7307" /> : <EyeIcon className="w-5 h-5" data-id="element-7308" />}
                </button>
              </div>
              {errors.password && <p className="mt-1 text-sm text-red-600" data-id="element-7309">{errors.password}</p>}
              <p className="mt-1 text-xs text-gray-500" data-id="element-7310">
                Minim 8 caractere, inclusiv litere și cifre
              </p>
            </div>
            <div data-id="element-7311">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-7312">
                Confirmă parola
              </label>
              <div className="relative" data-id="element-7313">
                <input type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className={`w-full px-4 py-3 border ${errors.confirmPassword ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-[#357BEB] focus:border-transparent pr-12`} placeholder="••••••••" data-id="element-7314" />
                <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700" data-id="element-7315">
                  {showConfirmPassword ? <EyeOffIcon className="w-5 h-5" data-id="element-7316" /> : <EyeIcon className="w-5 h-5" data-id="element-7317" />}
                </button>
              </div>
              {errors.confirmPassword && <p className="mt-1 text-sm text-red-600" data-id="element-7318">
                  {errors.confirmPassword}
                </p>}
            </div>
            <div data-id="element-7319">
              <label className="flex items-start" data-id="element-7320">
                <input type="checkbox" checked={acceptTerms} onChange={e => setAcceptTerms(e.target.checked)} className="w-4 h-4 text-[#357BEB] border-gray-300 rounded focus:ring-[#357BEB] mt-1" data-id="element-7321" />
                <span className="ml-2 text-sm text-gray-600" data-id="element-7322">
                  Accept{' '}
                  <Link to="/terms" className="text-[#357BEB] hover:underline" data-id="element-7323">
                    Termenii & Condițiile
                  </Link>{' '}
                  și{' '}
                  <Link to="/privacy" className="text-[#357BEB] hover:underline" data-id="element-7324">
                    Politica de confidențialitate
                  </Link>
                </span>
              </label>
              {errors.terms && <p className="mt-1 text-sm text-red-600" data-id="element-7325">{errors.terms}</p>}
            </div>
            <button type="submit" className="w-full bg-[#357BEB] text-white py-3 rounded-lg font-semibold hover:bg-[#2868d8] transition-colors" data-id="element-7326">
              Creează cont
            </button>
          </form>
          <div className="mt-6 text-center" data-id="element-7327">
            <p className="text-sm text-gray-600" data-id="element-7328">
              Ai deja cont?{' '}
              <Link to="/auth/login" className="text-[#357BEB] hover:underline font-semibold" data-id="element-7329">
                Autentifică-te
              </Link>
            </p>
          </div>
        </div>
      </motion.div>
    </div>;
}